<div class="container-fluid mt-5">
    <!-- Table -->
    <div class="row">
        <div class="col">
            <div class="card shadow p-4">
                <div class="row">
                    <div class="col-lg-8 mb-3">
                        <div class="w-100">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="h2 text-uppercase">Prix de la session</div>
                                <div *ngIf="currentStudio && !loading" class="text-danger h2 font-weight-bolder">
                                    {{currentStudio.price}} € / HEURE
                                </div>
                                <!-- shimmer -->
                                <div *ngIf="loading" class="shimmer w-50 mb-2" style="height: 30px;"></div>
                            </div>
                            <div class="d-flex align-items-center border rounded border-gray-200 p-4 mb-3">
                                <img *ngIf="currentStudio && !loading" [src]="currentStudio.thumbnail" alt="studio"
                                    height="100" width="100" class="object-cover rounded">
                                <div *ngIf="currentStudio && !loading" class="p-3">
                                    <span class="h2">{{currentStudio.name}}</span>
                                    <br>{{currentStudio.postal_code}}
                                    {{currentStudio.city}} {{currentStudio.country}}
                                </div>
                                <!-- shimmer -->
                                <div *ngIf="loading" class="shimmer w-50 mb-4" style="height: 150px;"></div>
                                <div *ngIf="loading" class="w-100 p-3">
                                    <div class="shimmer w-50" style="height: 25px;"></div><br>
                                    <div class="shimmer w-75" style="height: 20px;"></div>
                                </div>
                            </div>
                            <div *ngIf="currentStudio && !loading">
                                <h4><strong>Début : </strong>{{params.start_date}}</h4>
                                <h4><strong>Fin : </strong>{{params.end_date}}</h4>
                            </div>
                            <!-- shimmer -->
                            <div *ngIf="loading">
                                <div class="shimmer w-50" style="height: 25px;"></div><br>
                                <div class="shimmer w-50" style="height: 25px;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="h2 text-uppercase">Détails du paiement</div>
                        <hr class="my-2">
                        <div class="" *ngIf="final_price && price_fees">
                            <h4 class="d-flex justify-content-between"><strong>{{currentStudio?.price}}€ x
                                    {{nbr_hours}} heures : </strong>{{ currentStudio.price * nbr_hours }} €</h4>
                            <h4 class="d-flex justify-content-between"><strong>Frais fixes : </strong>{{ price_fees?.fc
                                }} €</h4>
                            <h4 class="d-flex justify-content-between"><strong>Frais variables :
                                </strong>{{ price_fees?.vc }} %</h4>
                            <h4 class="d-flex justify-content-between"><strong>TVA : </strong>{{ price_fees?.tva }} %
                            </h4>
                            <hr class="my-2">
                            <h4 class="d-flex justify-content-between">
                                <strong>Total : </strong>
                                <span *ngIf="!promo_code_is_valid && !discount_periods_found"><strong>{{ final_price }} €</strong></span>
                                <span *ngIf="promo_code_is_valid || discount_periods_found"><del><strong>{{ final_price }} €</strong></del></span>
                            </h4>

                            <h4 class="d-flex justify-content-between" *ngIf="promo_code_is_valid || discount_periods_found">
                                <strong>Réduction : </strong><span><strong class="text-danger">-{{ reduce_value }}
                                        €</strong></span>
                            </h4>
                            <h4 class="d-flex justify-content-between" *ngIf="promo_code_is_valid || discount_periods_found">
                                <strong>Montant à payer : </strong><strong>{{ final_price_after_apply_promo }}
                                    €</strong>
                            </h4>
                        </div>
                        <!-- shimmer -->
                        <div class="" *ngIf="!final_price">
                            <div class="shimmer w-100" style="height: 25px;"></div>
                            <div class="shimmer w-100" style="height: 25px;"></div>
                            <div class="shimmer w-100" style="height: 25px;"></div>
                            <div class="shimmer w-100" style="height: 25px;"></div>
                            <hr class="my-2">
                            <div class="shimmer w-100" style="height: 25px;"></div>
                        </div>

                    </div>
                    <div class="col-12">
                        <div *ngIf="!is_connected" class="my-2">Vous n'êtes pas connecté</div>
                        <button type="button" *ngIf="!is_connected" (click)="login()"
                            class="btn btn-studiomap me-2 mb-2"><i class="ni ni-key-25 mr-2"></i>Se connecter</button>
                        <button type="button" *ngIf="is_connected" (click)="startPayment()"
                            class="btn btn-studiomap me-2 mb-2"><i class="ni ni-credit-card mr-2"></i>Payer
                            maintenant</button>
                        <button type="button" (click)="changeDates()" class="btn btn-outline-studiomap me-2 mb-2"><i
                                class="ni ni-calendar-grid-58 mr-2"></i>Modifier les dates</button>

                        <button type="button" (click)="help()" class="btn btn-dark me-2 mb-2"><i
                                class="fa fa-question mr-2"></i>Comment ça marche</button>
                    </div>
                </div>
                <div *ngIf="!loading && errors" class="text-center">
                    <p class="text-center">{{errors}}<br>
                        <a href="javascript:void(0)" (click)="navigateTo('contact')"> Veuillez contacter notre
                            support</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>